export default __webpack_public_path__ + "static/media/substrate-illustration.ba986b9c.svg";